//export const API_ENDPOINT = 'http://localhost:8200'
export const API_ENDPOINT = 'https://api.modelmeai.com'

